import React from "react";
import Banner from "../Banner/Banner";
import Volunteers from "../Volunteers/Volunteers";
import Award from "../Award/Award";

function HomePage() {
  return (
    <div style={{marginTop:'4%'}}>
      <Banner />
      <Award />
      <Volunteers />
      {/* <AboutUs/> */}
      {/* <Testimonial/> */}
      {/* <Teams/> */}
      {/* <ContactUs /> */}
    </div>
  );
}

export default HomePage;
